import React from 'react';

import * as S from './styles';

function Airplane() {
  return <S.IoAirplane />;
}

export default Airplane;